import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hs-spinny-spin',
  templateUrl: './spinny-spin.component.html',
  styleUrls: ['./spinny-spin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnySpinComponent implements OnInit {

  @Input() size: number = 10;
  @Input() black: boolean = false;
  @Input() white: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
